import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox", "fill"];
const _hoisted_2 = ["fill", "fill-opacity"];
const _hoisted_3 = ["fill", "fill-opacity"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExternalLinkIcon',
    props: {
        width: { default: 14 },
        height: { default: 14 },
        viewBox: { default: '0 0 14 14' },
        background: { default: 'none' },
        color: { default: 'white' },
        opacity: { default: 1 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                width: _ctx.width,
                height: _ctx.height,
                viewBox: _ctx.viewBox,
                fill: _ctx.background,
                xmlns: "http://www.w3.org/2000/svg"
            }, [
                _createElementVNode("path", {
                    d: "M4.92339 7.84C4.76883 8.00587 4.68469 8.22526 4.68869 8.45194C4.69269 8.67863 4.78452 8.89491 4.94484 9.05522C5.10515 9.21554 5.32143 9.30737 5.54812 9.31137C5.7748 9.31537 5.99419 9.23123 6.16006 9.07667L12.2501 2.98667V4.95833C12.2501 5.1904 12.3422 5.41296 12.5063 5.57705C12.6704 5.74115 12.893 5.83333 13.1251 5.83333C13.3571 5.83333 13.5797 5.74115 13.7438 5.57705C13.9079 5.41296 14.0001 5.1904 14.0001 4.95833V0.875C14.0001 0.642936 13.9079 0.420376 13.7438 0.256281C13.5797 0.0921871 13.3571 0 13.1251 0H9.04173C8.80966 0 8.5871 0.0921871 8.42301 0.256281C8.25892 0.420376 8.16673 0.642936 8.16673 0.875C8.16673 1.10706 8.25892 1.32962 8.42301 1.49372C8.5871 1.65781 8.80966 1.75 9.04173 1.75H11.0134L4.92339 7.84Z",
                    fill: _ctx.color,
                    "fill-opacity": _ctx.opacity
                }, null, 8, _hoisted_2),
                _createElementVNode("path", {
                    d: "M1.75006 5.54167C1.75006 4.73667 2.40339 4.08333 3.20839 4.08333H5.83339C6.06546 4.08333 6.28802 3.99115 6.45211 3.82705C6.61621 3.66296 6.70839 3.4404 6.70839 3.20833C6.70839 2.97627 6.61621 2.75371 6.45211 2.58961C6.28802 2.42552 6.06546 2.33333 5.83339 2.33333H3.20839C2.35749 2.33333 1.54144 2.67135 0.93976 3.27303C0.338081 3.87471 6.10352e-05 4.69076 6.10352e-05 5.54167V10.7917C6.10352e-05 11.6426 0.338081 12.4586 0.93976 13.0603C1.54144 13.662 2.35749 14 3.20839 14H8.45839C9.3093 14 10.1253 13.662 10.727 13.0603C11.3287 12.4586 11.6667 11.6426 11.6667 10.7917V8.16667C11.6667 7.9346 11.5745 7.71204 11.4104 7.54795C11.2464 7.38385 11.0238 7.29167 10.7917 7.29167C10.5597 7.29167 10.3371 7.38385 10.173 7.54795C10.0089 7.71204 9.91673 7.9346 9.91673 8.16667V10.7917C9.91673 11.5967 9.26339 12.25 8.45839 12.25H3.20839C2.40339 12.25 1.75006 11.5967 1.75006 10.7917V5.54167Z",
                    fill: _ctx.color,
                    "fill-opacity": _ctx.opacity
                }, null, 8, _hoisted_3)
            ], 8, _hoisted_1));
        };
    }
});
